import { render, staticRenderFns } from "./FlightsTable.vue?vue&type=template&id=68a8924e&scoped=true&"
import script from "./FlightsTable.vue?vue&type=script&lang=ts&"
export * from "./FlightsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8924e",
  null
  
)

export default component.exports